export default __webpack_public_path__ + "static/media/linuxlogo.fa9a9a70.png";